import * as types from './types'
import { initializeState } from '../../utils/helpers'

const initialState = initializeState()

export default function (state = initialState, action) {
  switch (action.type) {
    case types.COMPLETE_ITEM: {
      const { bundleId, itemId } = action.payload
      return {
        ...state,
        [bundleId]: { ...state[bundleId], [itemId]: true },
      }
    }

    case types.UNCOMPLETE_ITEM: {
      const { bundleId, itemId } = action.payload
      return {
        ...state,
        [bundleId]: { ...state[bundleId], [itemId]: false },
      }
    }

    default:
      return state
  }
}
